<template>
<div class="content">
  <q-table
    :title="$t('global.WorkJournal')"
    :data="items"
    :columns="columns"
    row-key="IdWork"
    :dense=true
    selection="single"
    :selected.sync="selectedRows"
    :loading="loading">

    <template slot="top-selection" slot-scope="props" >
      <div class="q-table-title">{{$t('global.WorkJournal')}}</div>
      <div>
        <q-btn color="secondary" flat :label="$t('global.Edit')" class="q-mr-sm" @click="editWork()" />
        <q-btn color="secondary" flat :label="$t('global.Delete')" @click="deleteWork()" />
        <q-btn v-if="$store.state.session.AccessLevel <= 20" color="secondary" flat :label="$t('global.Duplicate')" @click="dublicateWork()" />
      </div>
    </template>  
    
  </q-table>
</div>    
</template>

<script>
import { date } from 'quasar'
import axios from 'axios'
import qs from 'qs'
import {eventBus} from '../../main'
export default {
  name: 'WorkJournal',
  props: ['dateFrom', 'dateTo'],
  data: function () {
    return {
      form: {
        SessionId: null,
      },
      loading: false,
      selectedRows: [],
      items:[],
      columns: [
      {
        name: 'WorkStart',
        required: true,
        label: this.$t('global.WorkStart'),
        align: 'left',
        field: 'Starting',
        sortable: true,
        format: val => this.dateFormat(val)
      },
      {
        name: 'Ending',
        required: true,
        label: this.$t('global.WorkEnd'),
        align: 'left',
        field: 'Ending',
        sortable: true,
        format: val => this.dateFormat(val)
      },
      {
        name: 'MinutesUp',
        required: true,
        label: this.$t('global.HourMin5'),
        align: 'right',
        field: 'MinutesUp',
        sortable: true,
        format: val => this.elapsedFormat(val)
      },
      {
        name: 'GeoRegionDescription',
        required: true,
        label: this.$t('global.Field'),
        align: 'left',
        field: 'GeoRegionDescription',
        sortable: true
      },
      {
        name: 'Product',
        required: true,
        label: this.$t('global.Product'),
        align: 'left',
        field: 'Product',
        sortable: true
      },
      {
        name: 'Comment',
        required: true,
        label: this.$t('global.Comment'),
        align: 'left',
        field: 'Comment',
        sortable: false
      },
      {
        name: 'WorkDescription',
        required: true,
        label: this.$t('global.Task'),
        align: 'left',
        field: 'WorkDescription',
        sortable: true
      },  
      {
        name: 'FlexCost', 
        required: true,
        label: 'Flex Kosten',
        align: 'right',
        field: 'FlexCost',
        sortable: true,
        format: val => this.decFormat(val)
      },  
      ],
      columnHeaders: ['global.WorkStart','global.WorkEnd','global.HourMin5','global.Field','global.Comment','global.Task'],
      
    }     
  },
  methods: {
    editWork () {
      eventBus.$emit('editWork', this.selectedRows[0].IdWork)
    },
    deleteWork () {
      var self = this
      this.$q.dialog({
        title: this.$t('global.DeleteEntry'),
        message: this.$t('global.DeleteEntryQuestion'),
        color: 'primary',
        ok: true, // takes i18n value, or String for "OK" button label
        cancel: true, // takes i18n value, or String for "Cancel" button label
        preventClose: true,
        noBackdropDismiss: false, // gets set to "true" automatically if preventClose is "true"
        noEscDismiss: false, // gets set to "true" automatically if preventClose is "true"
        stackButtons: false,
        position: 'top',        
      })
      .then(() => {
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "deleteWork"
        this.form.IdWork = self.selectedRows[0].IdWork
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              this.$q.notify({ message: this.$t('global.EntryDeleted'), type: 'positive' })
              eventBus.$emit('workChange', null)
              self.selectedRows = []
            }
            else{
                this.$q.notify('ERROR')
            }
        })
        .catch(e => {
          this.$q.notify('ERROR')
          console.log(e);
        })
      })
      .catch(() => {
        //alert('Picked cancel')
      })
    },
    dublicateWork(){
        eventBus.$emit('dublicateWork', this.selectedRows[0])
    },
    loadData(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getWorkByUser"
      this.form.dateFrom = this.dateFrom
      this.form.dateTo = this.dateTo
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.items = response.data
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {
        this.$q.notify('ERROR')
        console.log(e);
      })
    },
     dateFormat(val) {
       
      //return date.formatDate(val + 'z', this.$store.state.session.DateTimeFormat)
      if(val == null){
        return null
      }
      return this.moment(val).format(this.$store.state.session.DateTimeFormat)
    },

    elapsedFormat(minutes){
      var h = Math.floor(minutes / 60);
      var m = minutes % 60;
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      return h + ':' + m;
    },

    onOk (data) { },
    onCancel () { },    
    onShow () { },
    onHide () { },   
    decFormat(val) {
      if(val == null){
        return ''
      }
      return val.toFixed(2)
    },
  },
  computed:{
  
  },
  mounted() {
    this.loadData()     
  },
  created () {
    eventBus.$on('workChange', (data) => {
      this.loadData()
    }),
    eventBus.$on('Bus_ChangeLocale', (data) => {
      var cnr = 0
      this.columnHeaders.forEach(col => {
      this.columns[cnr].label = this.$t(col)
      cnr++
      })
    })
  },
  beforeDestroy(){
    
  },
  watch: {
    dateFrom: function (val) {
      this.loadData()
    },
    dateTo: function (val) {
      this.loadData()
    },
  },
}
</script>
<style scoped>
.content{
  padding: 10px;
}
</style>
